import React, { useRef } from 'react';
import { MenuItem } from 'primereact/menuitem';
import { Menu } from 'primereact/menu';
import { usePermissionContext } from 'contexts/PermissionContext';
import { Button as PrimeButton, ButtonProps } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons';
import './NotificationsTooltip.scss';

const NotificationActionToggle = ({ menuItems }: { menuItems: MenuItem[] }) => {
  const actionRef = useRef<Menu>(null);
  const menuRootWrapperRef = useRef<HTMLDivElement>(null);
  const { userIsDeactivatedWithActiveOrderlines } = usePermissionContext();
  const toggleNotificationAction: ButtonProps['onClick'] = event => {
    event.stopPropagation();
    if (actionRef && actionRef.current) {
      actionRef.current.toggle(event);
    }
  };

  return (
    <div ref={menuRootWrapperRef} className="notification-actions-wrapper">
      <Menu
        className="orderline-actions-menu"
        ref={actionRef}
        popup
        id="popup_menu_right"
        popupAlignment="right"
        model={menuItems}
      />
      <PrimeButton
        className="notification-action-btn"
        disabled={userIsDeactivatedWithActiveOrderlines}
        icon={
          <FontAwesomeIcon
            icon={faEllipsisV}
            color={userIsDeactivatedWithActiveOrderlines ? '#EAECF0' : '#757575'}
            style={{ fontSize: 20 }}
          />
        }
        onClick={toggleNotificationAction}
        aria-controls="popup_menu_right"
        aria-haspopup
      />
    </div>
  );
};

export default NotificationActionToggle;
